/* eslint-disable max-len */
import { cx } from 'emotion';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import ResultMessageBootstrap, { WinMessageBasic } from '@ezugi/bootstrap/src/features/game-results/ResultMessage';
import { useGameResults } from '@ezugi/bootstrap/src/features/game-results/useGameResults';
import { numbersAreEqual } from '@ezugi/utils';

import { dynamicMultipliersSelector, gameResultsSelector } from '../../store/selectors/game';
import ResultDisplay from './ResultDisplay';
import { resultMessageClassName } from './ResultDisplay/style';
import Canvas from './WinMessage/Canvas';
import { multiplierWinClassName } from './WinMessage/style';

const ResultMessage = () => {
  const { winAmount } = useGameResults();

  const multipliers = useSelector(dynamicMultipliersSelector);
  const gameResults = useSelector(gameResultsSelector) as Record<string, any>;

  const { winningBets = [] } = gameResults;

  // Whether or not the player has won a multiplier bet

  // TODO: types
  const hasWonMultipliers = useMemo(
    () => winningBets.some(
      // @ts-ignore
      (bet) => multipliers.hasOwnProperty(bet.index) && numbersAreEqual(bet.WinAmount, bet.betValue * multipliers[bet.index].value, 0.000001)
    ),
    [ winningBets, multipliers ]
  );

  return (
    <ResultMessageBootstrap
      className={cx(
        resultMessageClassName,
        {
          [multiplierWinClassName]: hasWonMultipliers && winAmount.visible,
        }
      )}
    >
      <ResultDisplay />
      {winAmount.visible && (
        hasWonMultipliers
          ? <Canvas winAmount={winAmount} />
          : <WinMessageBasic winAmount={winAmount} />
      )}

    </ResultMessageBootstrap>
  );
};

export default ResultMessage;
